import queryString from "query-string";
export async function retrieveAmTokenData(baseUrl, payload) {
    const formattedPayload = queryString.stringify(payload);
    try {
        const res = await fetch(baseUrl + '/am/oauth2/realms/root/access_token', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: formattedPayload
        });
        return await res.json();
    }
    catch (e) {
        console.error('Error while retrieving access token:', e);
        return { message: 'Error while retrieving access token', error: e };
    }
}
export function logoutAM(baseUrl, redirectUrl) {
    const encodedRedirectUrl = encodeURIComponent(redirectUrl);
    window.location.href = baseUrl + '/lokus/am/frontend/logout?redirect=' + encodedRedirectUrl;
}
//# sourceMappingURL=AMRequests.js.map